import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import LoadingPanel from '@/component/common/LoadingPanel';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { panelSettingAtom } from '@/state/atom/panelAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import {
    helpdeskTicketListDefaultDrillDownDataAtom,
    helpdeskTicketListDefaultSelectedOptionAtom,
    helpdeskTicketListDrillDownDataAtom,
    helpdeskTicketListIsLoadingDrillDownDataAtom,
    helpdeskTicketListViewStructureAtom,
    helpdeskTicketListVisibilityAtom,
    helpdeskTicketNotIncludeAtom,
    helpdeskTicketSearchTagSuggestAtom,
    helpdeskTicketContainAnyAtom,
    helpdeskTicketLastUserActionAtom,
} from '@/state/atom/ticketAtom';
import { getUserListByProjectAtom, userAtom } from '@/state/atom/userAtom';
import { setPanelSelector } from '@/state/selector/panelSelector';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { Tooltip, Popover } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React, { useEffect, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
    autoReloadTicketList,
    getDrilldownDataAndSugguestionList,
    getProjectMemberList,
    getVisibleWidth,
    handleSearchTicketList
} from '../handler/HelpDeskTicketListHandler';
import {
    getDefaultDrilldownData,
    getHelpDeskListViews,
    isDisplayBtnAddView,
    onChangeVisibilitySetting
} from '../handler/HelpDeskViewHandler';
import {
    getDrilldownDataSelected,
    getDrilldownItemDataSelected
} from '../handler/KnowledgeTicketHandler';
import { isOpenButtonCreateTicket } from '../handler/TicketListHandler';
import ListTicket from '../List';
import '../Ticket.css';
import './HelpDeskTicketList.css';
import { DialogNoticeViewChanged } from './views/DialogNoticeViewChanged';
import { DialogViewNameError } from './views/DialogViewNameError';
import ViewHelpDeskList from './views/ViewHelpDeskList';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import SeemoreViewHelpdeskList from '@/component/ticketList/helpdeskSide/views/SeemoreViewHelpdeskList';
import AddViewHelpdeskList from '@/component/ticketList/helpdeskSide/views/AddViewHelpdeskList';
import HelpdeskListDrilldownSelected from '@/component/ticketList/helpdeskSide/HelpdeskListDrilldownSelected';
import HelpdeskListSearchInput from '@/component/ticketList/helpdeskSide/HelpdeskListSearchInput';
import '@/component/common/layout/tabs/TabsInfo.css';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import BulkActionHelpDesk from './elements/BulkActionHelpDesk';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import RenderTagFieldInForm from '@/component/ticketKnowledge/elements/RenderTagFieldInForm';
import RenderExportMenu from '@/component/ticketKnowledge/elements/RenderExportMenu';
import { getAllBookmarkUserCanUse, getListTagFieldOfForm } from '../../ticketKnowledge/handler/ListTicketKnowledgeHandler';

export default function HelpDeskTicketList(props) {
    const { API } = {...props};

    // Add new panel
    const addNewPanel = useSetRecoilState(setPanelSelector);

    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingView, setIsLoadingView] = useState(false);
    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);

    const [ticketList, setTicketList] = useState([]);
    const [currentSearchParams, setCurrentSearchParams] = useState({});

    const [contractType, setContractType] = useState(1);

    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    const [viewSelected, setViewSelected] = useState({});
    const [listView, setListView] = useState([]);
    const [openListViewHide, setOpenListViewHide] = useState(false);
    const [isOpenDialogViewNameError, setIsOpenDialogViewNameError] = useState(false);
    const [isOpenDialogViewChanged, setIsOpenDialogViewChanged] = useState(false);
    const [viewNameErrorType, setViewNameErrorType] = useState('');

    // view / keyword
    const [viewStructure, setViewStructure] = useRecoilState(helpdeskTicketListViewStructureAtom);
    const [keywordSearch, setKeywordSearch] = useState(viewStructure.keyword);
    const [triggerSearch, setTriggerSearch] = useState('');

    const inputViewNameRef = useRef();
    const inputKeyWordRef = useRef();

    // DrillDown data
    const [isLoadingDrillDown, setIsLoadingDrillDown] = useRecoilState(
        helpdeskTicketListIsLoadingDrillDownDataAtom
    );
    const [drillDownData, setDrillDownData] = useRecoilState(helpdeskTicketListDrillDownDataAtom);
    const [drilldownDataSelected, setDrillDownDataSelected] = useState([]);
    const [sugguestionList, setSugguestionList] = useState([]);
    const setSettingSlideRecoilState = useSetRecoilState(panelSettingAtom);
    const [defaultDrillDownData, setDefaultDrillDownData] = useRecoilState(
        helpdeskTicketListDefaultDrillDownDataAtom
    );

    // Search option
    const [optionSearchTime, setOptionSearchTime] = useState('');
    const setDefaultSelectedOption = useSetRecoilState(helpdeskTicketListDefaultSelectedOptionAtom);
    const [isInitView, setIsInitView] = useState(true);

    const helpDeskVisibilityInState = useRecoilValue(helpdeskTicketListVisibilityAtom);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);

    // Assignee
    const userListRecoilValue = useRecoilValue(getUserListByProjectAtom);
    const [projectUserList, setProjectUserList] = useState([]);

    // common fieldList state

    const [triggerInterval, setTriggerInterval] = useState('');
    const nodeListView = document.querySelectorAll('.item-helpdesk');
    const element = document.querySelector('#container');

    const [lastedCountList, setLastedCountList] = useState(0);
    const [fromTicket, setFromTicket] = useState(0);
    const [totalTickets, setTotalTickets] = useState(0);
    const [removedTagItem, setRemovedTagItem] = useState({});
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom)
    const [searchContentType, setSearchContentType] = useState(LogKibanaConstant.CONTENT_TYPES_TICKET.QA)
    const [searchTagSuggest, setSearchTagSuggest] = useRecoilState(helpdeskTicketSearchTagSuggestAtom)
    const [searchContainAny, setSearchContainAny] = useRecoilState(helpdeskTicketContainAnyAtom);
    const [searchNotInclude, setSearchNotInclude] = useRecoilState(helpdeskTicketNotIncludeAtom);
    const [isShowDialogNotiLimit, setIsShowDialogNotiLimit] = useState(false);
    const [msgInProcessingIcon, setMsgInProcessingIcon] = useState("");
    const [isShowEditTagFields,setIsShowEditTagField] = useState(false);
    const [listTagFieldOfForm,setListTagFieldOfForm] = useState([]);
    const [selectedFormId, setSelectedFormId] = useState('')
    const [loadingBulkItemListTagField,setLoadingBulkItemListTagField] = useState(false);
    const [isShowDialogReload,setIsShowDialogReload] = useState(false)
    const [formTypePopover, setFormTypePopover] = useState(null);
    const isOpenFormTypePopover = Boolean(formTypePopover);
    const [isShowExportMenu, setIsShowExportMenu] = useState(false);
    const [isOpenDialogConfirm, setIsOpenDialogConfirm] = useState({
        status: false,
        action: '',
        params: {},
    });

    const clearMemoryLoadTicketList = () => {
        setIsLoading(false);
        setIsLoadingView(false);
        setTicketList([]);
        setDrillDownDataSelected([]);
        setDrillDownData([]);
        setSugguestionList([]);
        setDefaultDrillDownData([]);
        setProjectUserList([]);
        setViewSelected({});
        setListView([]);
    }

    const propsForListTicket = { ...props };
    delete propsForListTicket.corporationDetail;
    delete propsForListTicket.projectDetail;
    delete propsForListTicket.userDetail;
    delete propsForListTicket.setUserDetail;

    useEffect(() => {
        const fields = viewStructure.fields;
        const isSelectForm = fields?.find(field => {
           return !Utils.isEmptyString(field.form)
        });
        if(!isSelectForm){
            setIsShowEditTagField(false)
            setIsShowExportMenu(false)
        }
    },[viewStructure]);


    // update ticket list
    // init subscription ticket
    useEffect(() => {
        // Off interval in local
        if (process.env.NODE_ENV !== 'development') {
            let appDomain = process.env.REACT_APP_DOMAIN_NAME || '';
            let timeInterval = 60000;
            if (appDomain && appDomain.includes('dbdesk-test.ominext.dev')) {
                timeInterval = timeInterval*10;
            }
            const reloadTicketLists = setInterval(setGetListInterval, timeInterval);
            window.reloadTicketLists = reloadTicketLists;
            return () => clearInterval(reloadTicketLists);
        }
    }, []);

    useEffect(() => {
        const controller1 = new AbortController();
        setIsLoadingView(true);

        getHelpDeskListViews(
            API,
            setIsInitView,
            setViewSelected,
            setViewStructure,
            setListView,
            userDetail.id,
            projectInuseDetail.id,
            Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
            Constant.DEFINITION_VIEW.HELPDESK
        ).then((initListViews) => {
            setIsLoadingView(false);

            let newStructure = {
                ...JSON.parse(initListViews[0].structure),
                visibility: Constant.VISIBILITY_SETTING_TYPE.PRIVATE
            };

            getDefaultDrilldownData(
                API,
                Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
                newStructure,
                corporationDetail.id,
                projectInuseDetail.id,
                userDetail.id,
                setDefaultDrillDownData
            );
        });

        return () => {
            controller1.abort();
        }
    }, [projectInuseDetail]);

    const setGetListInterval = () => {
        // trick
        setTriggerInterval(Date.now().toString());
    };

    const initGetTicketLists = async (loading = true) => {
        const existsView = listView.some(item => item.id === viewSelected.id);
        if (Utils.isEmptyObject(projectInuseDetail) || isInitView || !existsView) return;

        const promiseGetDrilldownDataAndSugguestionList = async () => {
            setIsLoadingDrillDown(true);
            getDrilldownDataAndSugguestionList(
                API,
                viewStructure,
                corporationDetail.id,
                projectInuseDetail.id,
                userDetail.id,
                defaultDrillDownData,
                setCurrentSearchParams
            )
                .then(drillDownDataResult => {
                    setDrillDownData(drillDownDataResult.drillDownData);
                    setSugguestionList(drillDownDataResult.sugguestionList);
                })
                .catch((err) => {
                    console.log('getDrilldownDataAndSugguestionList err: ', err)
                })
                .finally(() => {
                    setIsLoadingDrillDown(false);
                });
        }

        getTicketLists(loading);

        await Promise.all([
            promiseGetDrilldownDataAndSugguestionList(),
            getProjectMemberList(userListRecoilValue, setProjectUserList, projectInuseDetail.id)
        ]);
    };

    const formIdSearchConditionFilterBy = () => {
        const fields = !Utils.isEmptyArray(viewStructure?.fields) ? viewStructure?.fields : [];
        const indexOfSelectedForm = fields?.find(field => {
            return !Utils.isEmptyString(field?.form)
        });

        return indexOfSelectedForm && indexOfSelectedForm['form'] ? indexOfSelectedForm['form'] : '';
    }

     // Check convertPdf in CorpRoot by selectedProject
     useEffect(() => {
        const controller9 = new AbortController();
        initDataForBulkActionTagField()
        
        return () => {
            controller9.abort();
        }
    }, [drillDownData, viewStructure?.fields?.length]);

    const initDataForBulkActionTagField = async () => {

        let allTagFieldForBulkAction = [];
        let promiseGetData = [getAllBookmarkUserCanUse(userDetail.id, projectInuseDetail.id, Constant.BOOKMARK_TARGET_TYPE.TICKET)];
        setLoadingBulkItemListTagField(true);

        let selectedForm = drillDownData?.find(drillDownDataItem => {
            return drillDownDataItem.id === Constant.DRILLDOWN_TYPE_TEXT.FORM;
        });

        const structure = Utils.convertJSONDataToObject(viewSelected.structure);
        const ticketProperty = structure?.ticketProperty;

        if (!Utils.isEmptyObject(selectedForm) && formIdSearchConditionFilterBy() && ticketProperty !== Constant.TICKET_PROPERTY.ARCHIVE) {
            const child = selectedForm.child;
            const formId = child[0]?.id;
            if (formId !== selectedFormId) {
                setSelectedFormId(formId);
            }
            if (!Utils.isEmptyString(formId)) {
                promiseGetData.push(getListTagFieldOfForm(formId, userDetail, projectInuseDetail, corporationDetail, null, projectInuseDetail.id));
            } 
        }

        let getDataTagResponse = await Promise.all(promiseGetData);

        let allBookmark = getDataTagResponse[0];
        if (!Utils.isEmptyArray(getDataTagResponse) && getDataTagResponse.length === 2) {
            let listTagField = getDataTagResponse[1];
            if (!Utils.isEmptyArray(listTagField)) {
                listTagField.forEach(tagField => {
                    let fieldata = {
                        ...tagField,
                        name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, tagField.name)
                    };
                    allTagFieldForBulkAction.push(fieldata);
                })
            }
        }

        if (!Utils.isEmptyArray(allBookmark)) {
            allBookmark = Utils.sortListByNameDictionaryASC(allBookmark);
            allTagFieldForBulkAction.push({
                id: [Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK, Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK],
                name: I18n.get('BOOKMARK_TAG'),
                listItem: allBookmark,
                isBookmark: true
            })
        }

        setListTagFieldOfForm([...allTagFieldForBulkAction]);

        setLoadingBulkItemListTagField(false);
    }

    // todo: hot fix for hidden loading
    useEffect(() => {
        const controller2 = new AbortController();
        if (triggerInterval) {
            let argsReloadTicketList = {
                API,
                corporationId: corporationDetail.id,
                projectId: projectInuseDetail.id,
                userId: userDetail.id,
                viewStructure,
                setViewStructure,
                setOptionSearchTime,
                defaultDrillDownData,
                inputKeyWordRef,
                lastedCountList,
                setLastedCountList,
                fromTicket,
                setFromTicket,
                setIsLoading,
                keywordSearch,
                setKeywordSearch,
                ticketList,
                setTicketList,
                setDrillDownDataSelected,
                setDrillDownData,
                setSugguestionList,
                setDefaultDrillDownData,
                setProjectUserList,
                setTotalTickets
            };
            autoReloadTicketList(argsReloadTicketList);
        }

        return () => {
            controller2.abort();
        }
    }, [triggerInterval]);

    useEffect(() => {
        const controller3 = new AbortController();
        initGetTicketLists();

        return () => {
            controller3.abort();
        }
    }, [
            props.triggerReload,
            projectInuseDetail.id,
            triggerSearch,
            viewStructure.fields.length,
            viewStructure.privateBookmark?.length,
            viewStructure.sharedBookmark?.length,
            viewStructure.statusFields?.length,
            viewStructure.tagFields?.length,
            viewStructure.keyword,
            viewStructure.visibility,
            viewStructure.ticketProperty,
            isInitView,
            viewSelected.id
    ]);

    useEffect(() => {
        setContractType(corporationDetail.contractType);

        return () => {
            clearMemoryLoadTicketList();
        }
    }, []);

    useEffect(() => {
        setIsShowEditTagField(false)
        setIsShowExportMenu(false)

        const controller4 = new AbortController();
        if (viewSelected && viewSelected.structure) {
            let newViewStructure = Utils.convertJSONDataToObject(viewSelected.structure);
            getDrilldownItemDataSelected(API, newViewStructure).then(drillDownDataRes => {
                setDefaultSelectedOption(
                    !Utils.isEmptyArray(drillDownDataRes) ? drillDownDataRes : []
                );
            });
            if (lastUserAction !== LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE) {
                setLastUserAction(LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE);
                setSearchTagSuggest([]);
            }
        }

        return () => {
            controller4.abort();
        }
    }, [viewSelected]);

    useEffect(() => {
        setIsShowEditTagField(false)
        setIsShowExportMenu(false)

        const controller5 = new AbortController();
        if (isInitView || isLoadingView) return;
        onChangeVisibilitySetting(
            API,
            setIsInitView,
            setViewSelected,
            viewStructure,
            setViewStructure,
            setListView,
            userDetail.id,
            projectInuseDetail.id,
            setIsLoadingView,
            helpDeskVisibilityInState,
            corporationDetail.id,
            setDefaultDrillDownData
        );
        // setGetListInterval();

        return () => {
            controller5.abort();
        }
    }, [helpDeskVisibilityInState]);

    const getTicketLists = async loading => {
        if (loading) setIsLoading(true);
        handleSearchTicketList(
            API,
            setTotalTickets,
            corporationDetail.id,
            projectInuseDetail.id,
            userDetail.id,
            viewStructure,
            setViewStructure,
            setOptionSearchTime,
            defaultDrillDownData,
            inputKeyWordRef,
            viewStructure.visibility ? viewStructure.visibility : helpDeskVisibilityInState,
            0,
            Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD,
            lastUserAction,
            corporationDetail,
            projectInuseDetail,
            userDetail,
            searchContentType,
            searchTagSuggest,
            searchContainAny,
            searchNotInclude,
            viewSelected,
            removedTagItem,
            setRemovedTagItem,
            setSearchTagSuggest
        )
            .then(async ticketListResult => {
                setLastedCountList(ticketListResult.length);
                setFromTicket(0);
                // Update keyword search
                if (viewStructure.keyword !== keywordSearch) {
                    setKeywordSearch(viewStructure.keyword);
                }
                setTicketList(ticketListResult);
                await getDrilldownDataSelected(API, viewStructure, setDrillDownDataSelected);
                setIsLoading(false);
            })
            .catch(error => {
                console.log('handleSearchTicketList err: ', error)
                setTicketList([]);
                setIsLoading(false);
            });
    };

    const handleAddPanel = async (e, selectedTicketType) => {
        // console.log('177259 handleAddPanel', props)
        addNewPanel( {
            type: Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
            tabId: `HELPDESK_NEW_TICKET_TAB_${Date.now().toString()}`,
            props,
            selectedTicketType
        });
        setFormTypePopover(null)
    };

    const handleOptionsTicketTypeToCreate = (e) => {
        if (Utils.isPublicOffDeskOff(projectInuseDetail)) {
            return handleAddPanel(e, Constant.HELPDESK_CREATE_TICKET_TYPE.TASK);
        }
        setFormTypePopover(e.currentTarget)
    }
    
    const renderContentTab = () => {
        return (
            <div className="content-tab-body">
                <HelpdeskListSearchInput
                    API={API}
                    inputKeyWordRef={inputKeyWordRef}
                    keywordSearch={keywordSearch}
                    setKeywordSearch={setKeywordSearch}
                    sugguestionList={sugguestionList}
                    viewStructure={viewStructure}
                    setViewStructure={setViewStructure}
                    setTriggerSearch={setTriggerSearch}
                    userDetail={userDetail}
                    projectInuseDetail={projectInuseDetail}
                    corporationDetail={corporationDetail}
                    addNewPanel={addNewPanel}
                    panelId={props.panelId}
                    lastUserAction={lastUserAction}
                    setLastUserAction={setLastUserAction}
                    setSearchTagSuggest={setSearchTagSuggest}
                    searchTagSuggest={searchTagSuggest}
                />

                <HelpdeskListDrilldownSelected
                    drilldownDataSelected={drilldownDataSelected}
                    optionSearchTime={optionSearchTime}
                    setOptionSearchTime={setOptionSearchTime}
                    viewStructure={viewStructure}
                    setViewStructure={setViewStructure}
                    setTriggerSearch={setTriggerSearch}
                    setLastUserAction={setLastUserAction}
                    setRemovedTagItem={setRemovedTagItem}
                    projectInuseDetail={projectInuseDetail}
                    userDetail={userDetail}
                />

                <BulkActionHelpDesk
                    listTicketHelpDesk={ticketList}
                    totalTickets={totalTickets}
                    viewSelected={viewSelected}
                    selectedProject={projectInuseDetail}
                    onSubmitSearchListHelpDesk={() => {
                        setTriggerSearch(Date.now().toString());
                    }}
                    currentSearchParams={currentSearchParams}
                    viewStructure={viewStructure}
                    drillDownData={drillDownData}
                    setIsShowDialogNotiLimit={setIsShowDialogNotiLimit}
                    msgInProcessingIcon={msgInProcessingIcon}
                    setMsgInProcessingIcon={setMsgInProcessingIcon}
                    setIsShowEditTagField={setIsShowEditTagField}
                    setIsShowExportMenu = {setIsShowExportMenu}
                    isOpenDialogConfirm={isOpenDialogConfirm}
                    setIsOpenDialogConfirm={setIsOpenDialogConfirm}
                />
                {isShowEditTagFields && (
                    <RenderTagFieldInForm
                        setIsShowEditTagField={setIsShowEditTagField}
                        listTagFieldOfForm={listTagFieldOfForm}
                        drillDownData={drillDownData}
                        totalTickets={totalTickets}
                        currentSearchParams={currentSearchParams}
                        setIsShowDialogReload = {setIsShowDialogReload}
                        setIsShowDialogNotiLimit={setIsShowDialogNotiLimit}
                        msgInProcessingIcon={msgInProcessingIcon}
                        setMsgInProcessingIcon={setMsgInProcessingIcon}
                        loadingBulkItemListTagField={loadingBulkItemListTagField}
                        action={Constant.BULK_ACTION.HELPDESK_EDIT_TAG_FIELD}
                        selectedFormId={{selectedFormId}}
                    />
                )}
                {isShowExportMenu && (
                    <RenderExportMenu
                        action={Constant.BULK_ACTION.HELPDESK_EXPORT_CSV}
                        setIsShowExportMenu={setIsShowExportMenu}
                        setIsOpenDialogConfirm={setIsOpenDialogConfirm}
                        currentSearchParams={currentSearchParams}
                    />
                )}
                <ConfirmDialog
                    isOpen={isShowDialogReload}
                    msgConfirm={I18n.get('COMMSG030')}
                    okCallBack={() => window.location.reload()}
                />

                <div className="mainFlex">
                    <div className={`col2 ${Utils.isEmptyArray(ticketList) && 'border-top'}`}>
                        {Utils.isEmptyArray(ticketList) ? (
                            <div
                                className="listEmpty listEmpty-qa"
                                data-cy="label-ticket-list-empty"
                            >
                                <span className="listEmpty-item">
                                    <img src="/assets/image/icon-listEmpty.svg" alt="" />
                                </span>
                                {I18n.get('COMMSG001')}
                            </div>
                        ) : (
                            <ListTicket
                                {...propsForListTicket}
                                API={props?.API}
                                ticketList={ticketList}
                                setTicketList={setTicketList}
                                ticketListType={props.ticketListType}
                                panelType={props.panelType}
                                setTriggerSearch={setTriggerSearch}
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                                isProjectManager={isProjectManager}
                                projectUserList={projectUserList}
                                panelId={props.panelId}
                                fromTicket={fromTicket}
                                setFromTicket={setFromTicket}
                                lastedCountList={lastedCountList}
                                setLastedCountList={setLastedCountList}
                                inputKeyWordRef={inputKeyWordRef}
                                setSugguestionList={setSugguestionList}
                                sugguestionList={sugguestionList}
                                viewStructure={viewStructure}
                                setViewStructure={setViewStructure}
                                setOptionSearchTime={setOptionSearchTime}
                                defaultDrillDownData={defaultDrillDownData}
                                keywordSearch={keywordSearch}
                                setKeywordSearch={setKeywordSearch}
                                drilldownDataSelected={drilldownDataSelected}
                                setDrillDownDataSelected={setDrillDownDataSelected}
                                isLoadingDrillDown={isLoadingDrillDown}
                                setIsLoadingDrillDown={setIsLoadingDrillDown}
                                setDrillDownData={setDrillDownData}
                                setTotalTickets={setTotalTickets}
                                triggerSearch={triggerSearch}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    };

    const renderListView = () => {
        let listViewShow = listView.filter(x => x.status === Constant.STATUS_VIEW.SHOW);
        let isDisplayNavTabs = listViewShow.length <= Constant.LIST_VIEW_TICKET_HELP_DESK;
        return (
            <div className="navTabs navTabs-flex">
                <div className="navTabs-group">
                    <DialogViewNameError
                        setIsOpenDialogViewNameError={setIsOpenDialogViewNameError}
                        inputViewNameRef={inputViewNameRef}
                        isOpenDialogViewNameError={isOpenDialogViewNameError}
                        viewNameErrorType={viewNameErrorType}
                    />
                    <DialogNoticeViewChanged
                        setIsOpenDialogViewChanged={setIsOpenDialogViewChanged}
                        setIsLoading={setIsLoading}
                        isOpenDialogViewChanged={isOpenDialogViewChanged}
                        userDetail={userDetail}
                        projectInuseDetail={projectInuseDetail}
                        viewStructure={viewStructure}
                        API={API}
                        tabs={listViewShow}
                        viewSelected={viewSelected}
                        setViewSelected={setViewSelected}
                        inputViewNameRef={inputViewNameRef}
                        setViewStructure={setViewStructure}
                        isProjectManager={isProjectManager}
                        listView={listView}
                        setListView={setListView}
                        setTriggerSearch={setTriggerSearch}
                        setIsLoadingView={setIsLoadingView}
                        setViewNameErrorType={setViewNameErrorType}
                        setIsOpenDialogViewNameError={setIsOpenDialogViewNameError}
                        setSettingSlideRecoilState={setSettingSlideRecoilState}
                        setIsInitView={setIsInitView}
                        corporationId={corporationDetail.id}
                        setDefaultDrillDownData={setDefaultDrillDownData}
                    />

                    {/* Render list view helpdesk list */}
                    <ViewHelpDeskList
                        API={API}
                        tabs={listViewShow}
                        viewSelected={viewSelected}
                        setViewSelected={setViewSelected}
                        inputViewNameRef={inputViewNameRef}
                        viewStructure={viewStructure}
                        setViewStructure={setViewStructure}
                        isProjectManager={isProjectManager}
                        listView={listView}
                        setListView={setListView}
                        setTriggerSearch={setTriggerSearch}
                        setIsLoadingView={setIsLoadingView}
                        setIsOpenDialogViewChanged={setIsOpenDialogViewChanged}
                        setViewNameErrorType={setViewNameErrorType}
                        setIsOpenDialogViewNameError={setIsOpenDialogViewNameError}
                        userDetail={userDetail}
                        projectInuseDetail={projectInuseDetail}
                        setSettingSlideRecoilState={setSettingSlideRecoilState}
                        setIsInitView={setIsInitView}
                    />
                </div>
                <div className="btnTabs-wrap">
                    {!isDisplayNavTabs && (
                        <SeemoreViewHelpdeskList
                            listViewShow={listViewShow}
                            viewSelected={viewSelected}
                            setViewSelected={setViewSelected}
                            viewStructure={viewStructure}
                            setViewStructure={setViewStructure}
                            setTriggerSearch={setTriggerSearch}
                            element={element}
                            nodeListView={nodeListView}
                            getVisibleWidth={getVisibleWidth}
                        />
                    )}

                    {isDisplayBtnAddView(isProjectManager, viewStructure.visibility) && (
                        <AddViewHelpdeskList
                            API={API}
                            setIsLoading={setIsLoading}
                            element={element}
                            getVisibleWidth={getVisibleWidth}
                            listView={listView}
                            setListView={setListView}
                            openListViewHide={openListViewHide}
                            setOpenListViewHide={setOpenListViewHide}
                            viewStructure={viewStructure}
                            setViewStructure={setViewStructure}
                            isProjectManager={isProjectManager}
                            userDetail={userDetail}
                            projectInuseDetail={projectInuseDetail}
                            corporationDetail={corporationDetail}
                            setIsOpenDialogViewChanged={setIsOpenDialogViewChanged}
                            viewSelected={viewSelected}
                            setViewSelected={setViewSelected}
                            setIsLoadingView={setIsLoadingView}
                            setTriggerSearch={setTriggerSearch}
                        />
                    )}

                    {isOpenButtonCreateTicket(
                        userDetail,
                        contractType,
                        props.ticketListType,
                        projectInuseDetail
                    ) && (
                        <>
                            <Tooltip title="新規作成">
                                <button
                                    className="btn-add-ticket"
                                    onClick={e => handleOptionsTicketTypeToCreate(e) }
                                >
                                    <img
                                        src="/assets/image/icon-add-ticket.svg"
                                        alt="icon-add-ticket"
                                    />
                                    <span className="text-add-ticket">作成</span>
                                </button>
                            </Tooltip>
                            <Popover
                                className="ticket-types-manager"
                                style={{ width: 'auto' }}
                                id={isOpenFormTypePopover ? 'simple-popover' : undefined}
                                open={isOpenFormTypePopover}
                                anchorEl={formTypePopover}
                                onClose={() => setFormTypePopover(null)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                }}
                            >
                                <ul>
                                    {(Utils.isPublicDesk(projectInuseDetail) ||
                                        Utils.isPrivateDesk(projectInuseDetail) || 
                                        Utils.isProjectGuestDesk(projectInuseDetail)) && (
                                        <>
                                            <li
                                                className="active"
                                                onClick={e =>
                                                    handleAddPanel(
                                                        e,
                                                        Constant.HELPDESK_CREATE_TICKET_TYPE.NOTICE
                                                    )
                                                }
                                            >
                                                
                                                <span className="text">
                                                    {I18n.get('FIELDFORMBTN008')}
                                                </span>
                                            </li>
                                            <li
                                                onClick={e =>
                                                    handleAddPanel(
                                                        e,
                                                        Constant.HELPDESK_CREATE_TICKET_TYPE
                                                            .DELEGATE
                                                    )
                                                }
                                            >
                                                <span className="text">
                                                    {I18n.get('問い合わせ代理発行')}
                                                </span>
                                            </li>
                                        </>
                                    )}
                                    {Utils.isPublicDesk(projectInuseDetail) && (
                                        <>
                                            <li
                                                onClick={e =>
                                                    handleAddPanel(
                                                        e,
                                                        Constant.HELPDESK_CREATE_TICKET_TYPE
                                                            .INVITATION_GUEST
                                                    )
                                                }
                                            >
                                                
                                                <span className="text">
                                                    {I18n.get('サポート窓口追加')}
                                                </span>
                                            </li>
                                        </>
                                    )}
                                    <li
                                        onClick={e =>
                                            handleAddPanel(
                                                e,
                                                Constant.HELPDESK_CREATE_TICKET_TYPE.TASK
                                            )
                                        }
                                    >
                                        <span className="text">{I18n.get('タスク')}</span>
                                    </li>
                                    {Utils.isEnableCreateEmailTicketMode(corporationDetail, projectInuseDetail) && (
                                        <>
                                            <li
                                                onClick={e =>
                                                    handleAddPanel(
                                                        e,
                                                        Constant.HELPDESK_CREATE_TICKET_TYPE
                                                            .EMAIL
                                                    )
                                                }
                                            >
                                                
                                                <span className="text">
                                                    {I18n.get('メール')}
                                                </span>
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </Popover>
                        </>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="mainWrap">
            <LoadingPanel isLoading={isLoading || isLoadingView} />
            <div className="customMainTop">{renderListView()}</div>

            <div className="contentTab">{renderContentTab()}</div>
            {/* End new code */}

            {/* <ErrorModal
                open={isModalUploadFileError}
                message={`${fileUploading?.file?.name} ${I18n.get('USER04MSG004')}`}
                handleCloseDialog={() => setIsModalUploadFileError(false)}
                title={'Upload fail'}
            ></ErrorModal> */}
            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <ConfirmDialog
                isOpen={isShowDialogNotiLimit}
                msgConfirm={I18n.get('MSG-CM-EXCEED-MAX-CONTENT-BULK-ACTION')}
                okCallBack={() => setIsShowDialogNotiLimit(false)}
            />
        </div>
    );
}
